import React from 'react';
import { List } from 'semantic-ui-react'
import {flowRight as compose} from 'lodash';
import general from '../../../modulos/general';
import {graphql} from 'react-apollo';

//utils
import queries from '../../../utils/queries'

import TitDer from '../../../components/funcionales/titder';
var moment = require('moment');

const DetalleNivel1 = ({styles, elemento, handleClickidLista}) => { 
  let urlSlcm = 'https://montserratslcm.com/api/cotizaciones/'

  let fechaHoy = new Date()
  fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
  fechaHoy=moment(fechaHoy)
  var fecFin=moment(elemento.fechaAut).format('YYYY-MM-DD')
  let numDias= fechaHoy.diff(fecFin, 'days')-1 

  let colorCelda='white'
  if(numDias!=='' && numDias!==null){
    if(numDias>3){
      colorCelda = 'red'
    }else{
      if(numDias>=2){
        colorCelda = 'yellow'
      }else{
        colorCelda = 'green'
      }
    }
  } 
  return (
    // <tr className='' onClick={(ev)=>handleClickidLista(ev, elemento)}>
    <tr className=''>
      <td className='left aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
          background: '#ffffff'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.fechaAut?elemento.fechaAut.substr(0, 10):''}</td>
      <td className='left aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
          background: '#ffffff'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.usuarioCreate}</td>
      <td className='left aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
          background: '#ffffff'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.numCoti}</td>
      <td className='left aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
          background: '#ffffff'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.descrEmpresa}</td>
      <td className='left aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
          background: '#ffffff'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.ordenCompraCliente?elemento.ordenCompraCliente:''}</td>
      <td className='left aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
          background: '#ffffff'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.nombreContacto?elemento.nombreContacto:''}</td>
      <td className='left aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
          background: '#ffffff'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.ciudadContacto?elemento.ciudadContacto:''}</td>
      <td className='left aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
          background: '#ffffff'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.mailContacto?elemento.mailContacto:''}</td>
      <td className='left aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
          background: '#ffffff'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.telContacto?elemento.telContacto:''}</td>
      <td className='left aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
          background: colorCelda}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{numDias}</td>
      <td className='left aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
          background: '#ffffff'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.observaciones?elemento.observaciones:''}</td>
      <td className='' style={{color: 'black', background: '#FFFFFF'}}>
        <a style={{color: 'black'}}
          // href={'images/cotizaciones/' + elemento.archivoRecibido}
          href={urlSlcm + elemento.archivoRecibido}
            target="_blank">
          {elemento.archivoRecibido}
        </a>
      </td>
   </tr>  
  )
};

const ListaF = ({list, handleClickidLista}) => { 
  const nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento}
        handleClickidLista={handleClickidLista}
        key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

class AdminTrasladoFin2 extends React.Component { 
  state = {argsBuscCad: {}, 
    argsQuery: `{$match: {tipoCoti: 'Traslado', estadoCoti: {$in: ['Aprobada']}}},
    {$project: {_id: 1, fechaAut: 1, descrEmpresa: 1, numCoti: 1, usuarioAut: 1, direccion: 1, archivoRecibido: 1, ordenCompraCliente: 1, 
        nombreContacto: 1, ciudadContacto: 1, mailContacto: 1, telContacto: 1, observaciones: 1}},
    {$lookup: {from: 'usuarios', localField: 'usuarioAut', foreignField: 'email', as: 'usuario'}},
    {$unwind: '$usuario'},
    {$project: {_id: 1, fechaAut: 1, descrEmpresa: 1, numCoti: 1, usuarioAut: 1, direccion: 1, archivoRecibido: 1, ordenCompraCliente: 1, 
      nombreContacto: 1, ciudadContacto: 1, mailContacto: 1, telContacto: 1, observaciones: 1, usuarioCreate: '$usuario.nombreUsuario'}}`
  }

  async componentDidUpdate (prevProps){ 
    if(this.props.argsBuscCad!==prevProps.argsBuscCad){
      let argsBuscar = `'descrEmpresa': {$ne: 'XXX'}`

      if(this.props.argsBuscCad.descrEmpresa){
        argsBuscar += `, 'descrEmpresa': /${this.props.argsBuscCad.descrEmpresa}/i`
      }          
      if(this.props.argsBuscCad.numCoti){
        argsBuscar += `, 'numCoti': /${this.props.argsBuscCad.numCoti}/i`
      }
      let argsBuscCad = `{$match: {${argsBuscar}}}, {$sort: {fechaAut: -1}}, {$limit: 100}`
      let argsBuscarIt = {tipoqry: `[${this.state.argsQuery}, ${argsBuscCad}]`}
      await this.props.allCotizacionRtesTras.refetch(argsBuscarIt)
    }else{
      if(this.props.allCotizacionRtesTras.allCotizacionRtes!==prevProps.allCotizacionRtesTras){
        this.props.allCotizacionRtesTras.refetch()
      }
    }
  }
  
render(){
  let list = []
  let listUsu = []
  // if(this.props.allUsuariosRtes.allUsuariosRtes){
  //   listUsu = this.props.allUsuariosRtes.allUsuariosRtes
  //   listUsu = listUsu.filter(elemento => elemento.email===localStorage.getItem('userLogin'))
  // }
  if(this.props.allCotizacionRtesTras.allCotizacionRtes){
    list = this.props.allCotizacionRtesTras.allCotizacionRtes
    // if(localStorage.getItem('userLogin')!=='slcm@slcm.com' && localStorage.getItem('userLogin')!=='felipe.albarracin@lubricaciondeclasemundial.com'){
    //   list = list.filter(elemento => elemento.nombreUsuarioOC===listUsu[0].nombreUsuario)
    // }
  }
    return (
      <div>
        <List selection>
          <TitDer list={list} textBoton1="Solicitudes de traslado iniciadas" btnNuevo={"NO"} styles={this.props.styles}/>
          
          <div style={{height: '35em', overflow: 'auto'}}>
            <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
              <thead className=''>
                <tr className=''>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Fecha solic.</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Usuario solic.</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Solicitud</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '11%'}}>Cliente</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}># Orden</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Contacto</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Ciudad</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Mail</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Teléfono</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Días asignación</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Observaciones</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Archivo cliente</th>
                </tr>
              </thead> 
              <ListaF list={list} handleClickidLista={this.props.handleClickidLista}/>
            </table>
            <p></p>
          </div>
        </List>

      </div>
    )
  }
};

export default compose(
  graphql(queries.query.allUsuariosRtes, {name:'allUsuariosRtes',
  options: (props) => {return {variables: {tipoqry: `[{$match: {nombreUsuario: {$ne: 'XXXXXXX'}}}]`}}}}),
  graphql(queries.query.allCotizacionRtes, {name:'allCotizacionRtesTras',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipoCoti: 'Traslado', estadoCoti: {$in: ['Aprobada']}}},
    {$project: {_id: 1, fechaAut: 1, descrEmpresa: 1, numCoti: 1, usuarioAut: 1, direccion: 1, archivoRecibido: 1, ordenCompraCliente: 1, 
        nombreContacto: 1, ciudadContacto: 1, mailContacto: 1, telContacto: 1, observaciones: 1}},
    {$lookup: {from: 'usuarios', localField: 'usuarioAut', foreignField: 'email', as: 'usuario'}},
    {$unwind: '$usuario'},
    {$project: {_id: 1, fechaAut: 1, descrEmpresa: 1, numCoti: 1, usuarioAut: 1, direccion: 1, archivoRecibido: 1, ordenCompraCliente: 1, 
      nombreContacto: 1, ciudadContacto: 1, mailContacto: 1, telContacto: 1, observaciones: 1, usuarioCreate: '$usuario.nombreUsuario'}}            
    ]`}}}}), 
)(AdminTrasladoFin2) 